import { useContext } from "react";
import { Button } from "../tailwind/button";
import { CustomerContext } from "../../providers";
import { Heading } from "../tailwind/heading";
import { Text } from "../tailwind/text";
import { EmbeddedGuideflow } from "../EmbeddedGuideflow";

export const CompleteWhatsAppProfile = () => {
  const { customer } = useContext(CustomerContext);

  return (
    <div className="">
      <Text>Go to your Meta Business Manager settings.</Text>
      <Button
        color="secondaryButton"
        className="mt-2 mb-5"
        onClick={() =>
          window.open(
            "https://business.facebook.com/wa/manage/phone-numbers/",
            "_blank"
          )
        }
      >
        Edit WhatsApp profile
      </Button>
      <Text>Add a profile picture (at least 640px x 640px).</Text>
      <div className="mt-2 mb-5">
        <EmbeddedGuideflow id={"vkmvzdlf2k"} />
      </div>

      <Text>You may also ask for certification.</Text>
    </div>
  );
};
